import React from "react";
import { Box, HStack, Text } from "@chakra-ui/react";

const SimpleBarChart = ({ values, colorScheme = "blue", height = 120 }) => {
  const safeValues = Array.isArray(values) && values.length > 0 ? values : Array(8).fill(0);
  const maxValue = Math.max(...safeValues);
  const barHeight = typeof height === "number" ? height : 120;
  const hasData = safeValues.some((value) => Number(value) > 0);

  if (!hasData) {
    return (
      <Box
        h={`${barHeight}px`}
        borderRadius="md"
        borderWidth="1px"
        borderStyle="dashed"
        borderColor="gray.200"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Text fontSize="sm" color="gray.500">
          No data for selected range.
        </Text>
      </Box>
    );
  }

  return (
    <HStack align="flex-end" spacing={2} h={`${barHeight}px`}>
      {safeValues.map((value, index) => {
        const normalized = value / (maxValue || 1);
        const minHeight = 6;
        const computedHeight = Math.max(minHeight, Math.round(normalized * barHeight));
        return (
          <Box
            key={`${index}-${value}`}
            flex="1"
            h={`${computedHeight}px`}
            bg={`${colorScheme}.300`}
            borderRadius="md"
          />
        );
      })}
    </HStack>
  );
};

export default SimpleBarChart;
